export default __webpack_public_path__ + "static/media/sk.9002eb80.svg";